export class HybseConfig {
  // apiURL:string = 'https://api.hybse.dev/';
  // apiURL:string = 'http://127.0.0.1:8000/';
  // apiURL:string = 'https://apollo.hybsedev.ddns.net/';
  // apiURL: string = 'https://apollo.business-software.in/api/';
  //  apiURL: string = 'https://apollo.hybse.com/api/';
  // apiURL: string = 'https://hybse-auth.business-software.in/api/';


  // div
  // apiURL: string = 'https://hybsev3.business-software.in/api/';
  // authURL: string = 'https://hybse-auth.business-software.in/api/';

  // stage
  // apiURL: string = 'https://apiv2.hybse.com/api/';
  // authURL: string = 'https://stageauth.hybse.com/api/';

  // prod and old_version
  // apiURL: string = 'https://stockv3.hybse.com/api/';
  // authURL: string = 'https://authv3.hybse.com/api/';

  // new_version
  // apiURL: string = 'https://stockv3.hybse.com/api/';
  // authURL: string = 'https://authv3.hybse.com/api/';

  // new_design url for dev:
  // apiURL: string = 'https://hbv3.business-software.in/api/';
  // authURL: string = 'https://hbauth.business-software.in/api/';

  // new_design url for prod:
  // apiURL: string = `https://stockv3.hybse.global/api/`;
  // authURL: string = `https://authv3.hybse.global/api/`;

   // new_design url for BEX prod:
  // apiURL: string = `https://v3.bex.global/api/`;
  // authURL: string = `https://auth.bex.global/api/`;
  // dev API
  apiURL:string = 'https://hbv3.business-software.in/api/';
  authURL: string = 'https://hbauth.business-software.in/api/';
}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/config/hybse.config.ts